import { Routes } from '@angular/router';
import { WorkorderDetailComponent } from 'src/workorders/workorder-detail/workorder-detail.component';
import { WorkordersHomeComponent } from 'src/workorders/workorders-home/workorders-home.component';
import { WorkordersListComponent } from 'src/workorders/workorders-list/workorders-list.component';
import { MsalGuard } from '@azure/msal-angular';

const routeConfig: Routes = [
  {
    path: '',
    redirectTo: '/workorders',
    pathMatch: 'full',
  },
  {
    path: 'workorders',
    component: WorkordersHomeComponent,
    canActivate: [MsalGuard],
    title: 'Work Orders',
    children: [
      {
        path: '',
        component: WorkordersListComponent,
      },
      {
        path: 'detail/:id',
        component: WorkorderDetailComponent,
      },
    ],
  },
];

export default routeConfig;
